import './text_area_component.scss'
import autosize from 'autosize'
import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['input']

  connect = (): void => {
    autosize(this.inputTarget)
    setTimeout(() => autosize.update(this.inputTarget), 500)
  }
}
